import React from "react";

const ErrorPage = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <iframe
        style={{ border: "none", width: "40rem", height: "40rem" }}
        src="https://lottie.host/embed/186b3805-19b0-4495-b4c7-92aa12b62be7/qXH67n2GNe.json"
      ></iframe>
    </div>
  );
};

export default ErrorPage;
